// globalHooks.ts
import { logger } from "./logging.js";
var hookMap = /* @__PURE__ */ new Map();
var addGlobalHook = (key, hook) => {
  let hooks = hookMap.get(key);
  if (!hooks)
    hooks = [];
  hooks.push(hook);
  hookMap.set(key, hooks);
};
var runGlobalHooks = async (key, { parallel, prefix, remove } = {}) => {
  const hooks = getHooks(key, prefix, remove);
  logger.info({ key, prefix, remove }, "Running hooks for group");
  if (parallel) {
    const results = await Promise.allSettled(hooks.map((hook) => hook()));
    results.forEach((result) => {
      if (result.status === "rejected")
        logger.warn({ err: result.reason, key, prefix, remove }, "Error while executing global hook group");
    });
    return;
  }
  for (const hook of hooks) {
    try {
      await hook();
    } catch (err) {
      logger.warn({ err, key, prefix, remove }, "Error while executing global hook group");
    }
  }
};
var runGlobalHooksSync = (key, { prefix, remove } = {}) => {
  logger.info({ key, prefix, remove }, "Running sync hooks for group");
  const hooks = getHooks(key, prefix, remove);
  for (const hook of hooks) {
    try {
      hook();
    } catch (err) {
      logger.warn({ err, key, prefix, remove }, "Error while executing global hook group");
    }
  }
};
var getHooks = (key, isPrefix, remove) => {
  if (!isPrefix) {
    const hooks2 = hookMap.get(key) ?? [];
    if (remove)
      hookMap.delete(key);
    return hooks2;
  }
  const keys = Array.from(hookMap.keys()).filter((mapKey) => mapKey.startsWith(key));
  const hooks = keys.flatMap((mapKey) => hookMap.get(mapKey) ?? []);
  if (remove)
    for (const mapKey of keys)
      hookMap.delete(mapKey);
  return hooks;
};
export {
  addGlobalHook,
  runGlobalHooks,
  runGlobalHooksSync
};
